import { render, staticRenderFns } from "./RouteConfigInfoList.vue?vue&type=template&id=822d38c0&"
import script from "./RouteConfigInfoList.vue?vue&type=script&lang=js&"
export * from "./RouteConfigInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports